import { http } from '@/api/http'
import type { FavoriteBody } from '@/api/types'

/** Избранное (§12 LOGIC.md): список — только id, переключение — одним тогглом. */
export const productService = {
  favorites: (customerId: string) => http.get<string[]>('/product/FavoriteProducts', { customerId }),
  toggleFavorite: (body: FavoriteBody) => http.post<unknown>('/product/Favorite', body),
}
